import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const PremisIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 145 35',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox} style={{ width: 145, height: 35 }}>
    <g id="Group_3343" data-name="Group 3343">
      <g id="Group_3263" data-name="Group 3263">
        <g id="Group_3262" data-name="Group 3262">
          <g id="Group_3260" data-name="Group 3260">
            <path
              id="Path_309"
              data-name="Path 309"
              fill="#0f3c57"
              d="M133.83,10.06h.31l.29,0a2.49,2.49,0,0,1,2,1.93c0,.11,0,.23,0,.34v.36a3.4,3.4,0,0,1-.09.46,2.42,2.42,0,0,1-1.88,1.75l-.33.05h-.31l-.34-.05A2.46,2.46,0,0,1,131.58,13a3.43,3.43,0,0,1-.06-.34v-.36a3.73,3.73,0,0,1,.09-.46,2.44,2.44,0,0,1,1.88-1.75Zm.16,4.52a2.06,2.06,0,1,0-2.05-2.06h0A2.05,2.05,0,0,0,134,14.58Z"
            />
            <path
              id="Path_310"
              data-name="Path 310"
              fill="#0f3c57"
              fillRule="evenodd"
              d="M133.34,12.77v1.11h-.42V11.24H134a1.19,1.19,0,0,1,.46.06.7.7,0,0,1,.42.89.59.59,0,0,1-.11.19.75.75,0,0,1-.51.3h-.07a.86.86,0,0,1,.36.32c.15.22.29.45.44.68,0,0,.07.11.11.17h-.47a.08.08,0,0,1-.07-.05l-.39-.67A1.84,1.84,0,0,0,134,13a.44.44,0,0,0-.35-.18Zm0-.38h.71a.65.65,0,0,0,.21-.05.36.36,0,0,0,.22-.44.36.36,0,0,0-.37-.28c-.23,0-.47,0-.7,0h-.07Z"
            />
          </g>
          <g id="Group_3261" data-name="Group 3261">
            <path
              id="Path_311"
              data-name="Path 311"
              fill="#0f3c57"
              d="M66.82,24H65.46V11.87h2.19a4.2,4.2,0,0,1,3,.86,3.34,3.34,0,0,1,1.13,2.56c0,2.1-1.47,3.39-3.83,3.39H66.82Zm1.09-6.53c1.67,0,2.59-.8,2.59-2.2s-.9-2.12-2.68-2.12h-1v4.32Z"
            />
            <path
              id="Path_312"
              data-name="Path 312"
              fill="#0f3c57"
              d="M83.2,24H81.54l-3.65-5.3h-.34V24H76.19V11.87h2a4.84,4.84,0,0,1,2.9.66,3.26,3.26,0,0,1,1.35,2.68,3.18,3.18,0,0,1-3.05,3.36Zm-4.8-6.5c1.75,0,2.67-.78,2.67-2.27s-.94-2.08-2.72-2.08h-.8v4.35Z"
            />
            <path
              id="Path_313"
              data-name="Path 313"
              fill="#0f3c57"
              d="M89.1,13.13v3.61h4.77V18H89.1v4.74H94V24H87.73V11.87H94v1.26Z"
            />
            <path
              id="Path_314"
              data-name="Path 314"
              fill="#0f3c57"
              d="M100.48,11.2l4.65,10.22,4.76-10.24L111.76,24h-1.39l-1.12-8.42-4.12,8.93-4.07-8.93L99.86,24H98.48Z"
            />
            <path
              id="Path_315"
              data-name="Path 315"
              fill="#0f3c57"
              d="M117.68,24h-1.33V11.87h1.32Z"
            />
            <path
              id="Path_316"
              data-name="Path 316"
              fill="#0f3c57"
              d="M128.45,14.25a2.12,2.12,0,0,0-2-1.31,1.88,1.88,0,0,0-1.94,1.8v.07a1.57,1.57,0,0,0,.74,1.31,5.52,5.52,0,0,0,.92.51l.37.18.37.17.37.16c1.88.85,2.66,1.82,2.66,3.32a3.69,3.69,0,0,1-3.63,3.74h-.07a3.59,3.59,0,0,1-3.65-3.12l1.27-.36c.32,1.45,1.13,2.21,2.36,2.21a2.35,2.35,0,0,0,2.4-2.3v-.08a2,2,0,0,0-1-1.72,7.2,7.2,0,0,0-1-.55l-.36-.18-.35-.16-.35-.16c-1.69-.78-2.38-1.64-2.38-3a3.15,3.15,0,0,1,3.29-3.11,3.31,3.31,0,0,1,3,1.89Z"
            />
          </g>
        </g>
      </g>
      <path
        id="Path_337"
        data-name="Path 337"
        fill="#fff"
        fillRule="evenodd"
        d="M21.91,17.54A17.38,17.38,0,1,1,39.34,34.88h-.09A17.35,17.35,0,0,1,21.91,17.54Zm34.25,0A16.87,16.87,0,1,0,39.24,34.36h0a16.84,16.84,0,0,0,16.87-16.8Z"
      />
      <path
        fill="#0f3c57"
        d="M39.34,35h-.09A17.49,17.49,0,0,1,21.79,17.54h0A17.51,17.51,0,0,1,39.25,0h0A17.5,17.5,0,0,1,51.7,29.84,17.36,17.36,0,0,1,39.34,35ZM39.29.24h0A17.28,17.28,0,0,0,22,17.54h0A17.25,17.25,0,0,0,39.25,34.76h.09A17.27,17.27,0,0,0,51.47,5.26,17.16,17.16,0,0,0,39.29.24Zm0,34.24h-.08a17,17,0,0,1-16.93-17A17,17,0,0,1,39.29.51h.06a17,17,0,0,1,16.93,17h0A17,17,0,0,1,39.32,34.48Zm0-33.73A16.74,16.74,0,0,0,27.42,29.3a16.62,16.62,0,0,0,11.82,4.94h.08A16.74,16.74,0,0,0,56,17.56h0A16.77,16.77,0,0,0,39.35.75Z"
      />
      <path
        id="Path_327"
        data-name="Path 327"
        fill="#0f3c57"
        fillRule="evenodd"
        d="M41.36,17.16l.2.15.14-.18,2.78-4c.13-.19.13-.19.32-.06l3.73,2.63c.17.12.17.14,0,.31l-3.07,4.33-.61.87a.61.61,0,0,1-.07.1c-.06.06-.1.07-.17,0l-.15-.1-2.84-2-.21-.15-.14.2.21.17,2.83,2,.11.07c.09.08.1.13,0,.23a.35.35,0,0,1,0,.08c-.68.95-1.36,1.91-2,2.87-.15.21-.16.21-.37.06l-3.58-2.5-.17-.12c-.07-.06-.07-.1,0-.18l.07-.11,1.17-1.66a1,1,0,0,0,.11-.15l-.2-.16-.1.13L37.26,23l-.8,1.14c-.09.14-.11.15-.25.05l-2.69-1.9-4.12-2.9c-.22-.16-.22-.16-.06-.38l3.6-5.09c0-.05.07-.11.12-.17a.12.12,0,0,1,.16,0h0l.13.09,6.75,4.72.14.1.14-.21-.11-.09-2-1.39-4.83-3.37c-.2-.14-.2-.14-.06-.34L37.09,8,37.15,8c.08-.11.14-.12.25,0l.07,0,6.66,4.68a1.09,1.09,0,0,1,.17.13.11.11,0,0,1,0,.15h0l-.09.13-2.79,4A.94.94,0,0,1,41.36,17.16Z"
      />
      <path
        id="Path_328"
        data-name="Path 328"
        fill="#0f3c57"
        fillRule="evenodd"
        d="M38.06,22.35l.2.12L41.94,25c.18.12.18.14.05.32-.32.46-.64.92-1,1.37l-.3.43c-.08.1-.11.11-.22,0l-.4-.28-3.28-2.3-.15-.11a.1.1,0,0,1,0-.15h0l.07-.11,1.2-1.7Z"
      />
    </g>
    <rect fill="none" width="260" height="35" />
  </SvgIcon>
);

export default PremisIcon;
